import { useRagnar } from '@mentimeter/ragnar-react';
import { Box } from '@mentimeter/ragnar-ui/box';
import { FullSizeContainer } from '@mentimeter/visualizations-react/utils/full-size-container';
import { RatingGrid } from '@mentimeter/visualizations-react/visualizations/rating-grid';

interface RatingScore {
  total: [number, number];
  responses: Array<[number, number]>;
}

interface RatingVisualizationProps {
  shouldAnimate: boolean;
  shouldHideResults: boolean;
  results: Array<{ id: number; score: RatingScore }>;
  choices: Array<{ id: number; label: string }>;
  range: { min: number; max: number };
  imageUrl: string | undefined;
  horizontalAxisLabel: string;
  verticalAxisLabel: string;
}

export const RatingVisualization = ({
  shouldAnimate,
  shouldHideResults,
  results,
  choices,
  range,
  imageUrl,
  horizontalAxisLabel,
  verticalAxisLabel,
}: RatingVisualizationProps) => {
  const {
    theme: {
      visualizationColors: { fillColors, textColor },
      colors: { neutral, bg },
      fonts: { body },
    },
  } = useRagnar();

  const colors = fillColors.length > 0 ? fillColors : [textColor];

  const staticOptions = choices.map((choice, index) => ({
    id: choice.id,
    label: choice.label,
    dotNumber: (index + 1).toString(),
  }));

  return (
    <Box width="100%" height="100%" px="4%">
      <FullSizeContainer>
        {(width, height) => (
          <RatingGrid
            width={width}
            height={height}
            colors={colors as [string, ...[string]]}
            textColor={textColor}
            backgroundColor={bg}
            image={
              imageUrl ? { url: imageUrl } : { placeholderImageColor: neutral }
            }
            data={shouldHideResults ? [] : results}
            staticOptions={staticOptions}
            fontFamily={body}
            disableAnimations={!shouldAnimate}
            range={range}
            horizontalAxisLabel={horizontalAxisLabel}
            verticalAxisLabel={verticalAxisLabel}
          />
        )}
      </FullSizeContainer>
    </Box>
  );
};
